<template>
    <div>
        <div class="fixtures-background"></div>
        <div class="row no-gutters justify-content-space-evenly h-100 pt-4 pt-xl-5 fixtures-wrapper">
            <div class="col-11 col-sm-8 col-xl-3 text-center">
                <v-date-picker
                        mode='single'
                        tint-color='#523064'
                        v-model='selectedDate'
                        :theme-styles='themeStyles'
                        is-inline class="fixtures-date-picker">
                </v-date-picker>
            </div>
            <div class="col-10 col-sm-9 col-xl-3 text-center">
                <accordion class="mb-4" :raceCourses="firstDropdown" :accordionId="1"></accordion>
                <accordion class="mb-4" :raceCourses="secondDropdown" :accordionId="2"></accordion>
                <accordion class="mb-4" :raceCourses="thirdDropdown" :accordionId="3"></accordion>
            </div>
            <div class="col-10 col-sm-9 col-xl-3 text-center">
                <accordion :raceCourses="fourthDropdown"></accordion>
            </div>
        </div>
    </div>
</template>

<script>
    import {firstDropdown, secondDropdown, thirdDropdown, fourthDropdown} from '../assets/mockData/raceCourses';

    import Accordion from '../components/Accordion.vue';

    export default {
        name: 'Fixtures',
        components: {Accordion},
        data() {
            return {
                selectedDate: null,
                firstDropdown: firstDropdown,
                secondDropdown: secondDropdown,
                thirdDropdown: thirdDropdown,
                fourthDropdown: fourthDropdown,
                themeStyles: {
                    wrapper: {
                        border: '1',
                    },
                    header: {
                        color: '#fafafa',
                        backgroundColor: '#000000',
                        borderColor: '#404c59',
                        borderWidth: '1px 1px 0 1px',
                    },
                    headerVerticalDivider: {
                        borderLeft: '1px solid #404c59',
                    },
                    weekdays: {
                        color: '#ffffff',
                        backgroundColor: '#000000',
                        borderColor: '#4C4C4C',
                        borderWidth: '0 1px',
                        padding: '5px 0 10px 0',
                    },
                    weekdaysVerticalDivider: {
                        borderLeft: '1px solid #404c59'
                    },
                    weeks: {
                        border: '1px solid #dadada',
                        backgroundColor: '#FFFFFF',
                    },
                },
            };
        },
        methods: {
            getImage(imagePath) {
                return require('../assets/images/' + imagePath + '.svg');
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .fixtures-background {
        background: url('../assets/images/fixtures-background.jpg') center no-repeat;
        background-size: cover !important;
        position: fixed;
        top: 8vh;
        width: 100vw;
        height: 92vh;
    }

    .fixtures-date-picker {
        box-shadow: 0 10px 12px -2px black;
        width: 100%;
        margin-bottom: 1.2rem;
    }

    @media (min-width: 1200px) {
        .fixtures-background {
            top: 0 !important;
            height: 100vh;
        }
    }

    @media (min-width: 1200px) {
        .fixtures-date-picker {
            width: 100% !important;
        }
    }
</style>
